import {Vue} from 'ui.vue';



import './BXmakerAuthuserphoneEnterSimPush.styl';


Vue.component('BXmakerAuthuserphoneEnterSimPush',
    {
        props: [

        ],
        data: function () {
            return {
                //последняя операция была - проверка?
                // для повторения операции после ввода капчи - при необходимости
                lastActionCheck: false,
            };
        },
        created() {
            if(this.$Bitrix.PullClient && this.$Bitrix.PullClient.get()) {
                this.unsubscribe = this.$Bitrix.PullClient.get().subscribe({
                    moduleId: 'bxmaker.authuserphone',
                    command: 'COMMAND_SIM_PUSH_CHECK',
                    callback: () => {
                        if (this.$root.isNeedShowConfirmSimPush) {
                            this.onClickCheck();
                        }
                    }
                });
            }

        },
        beforeDestroy() {
            if (typeof this.unsubscribe == 'function') {
                this.unsubscribe();
            }
        },
        computed: {

        },
        methods: {
            onClickCheck() {
                this.lastActionCheck = true;
                this.$root.checkConfirm();
            },
            onClickChangePhone() {
                this.lastActionCheck = false;
                this.$root.resetMessage();
                this.$root.resetCaptcha();
                this.$root.hideConfirm();
                this.$root.setSimPush('');
            },
            onClickStart() {
                this.lastActionCheck = false;
                this.$root.startConfirmSimPush();
            },
            onCompleteCaptcha() {
                //повторяем операцию последнюю
                if (this.lastActionCheck) {
                    this.onClickCheck();                    
                } else {
                    this.onClickStart();
                }
            },
            onCompleteTimeout(){
                this.$root.setSimPushTimeout(0);
            }
        },
        template: `
            <div class="bxmaker-authuserphone-enter-simpush"  >
              
                <slot name="header">                  
                    <BXmakerAuthuserphoneHeader>
                        {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_SIM_PUSH_TITLE}}
                    </BXmakerAuthuserphoneHeader>     
                </slot>
                
                <slot name="message">
                    <BXmakerAuthuserphoneMessage :message="$root.message" :error="$root.error" />  
                </slot>                  
                    
                <slot name="notice">
                    <div class="bxmaker-authuserphone-enter-simpush__notice">
                         {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_SIM_PUSH_NOTICE}} 
                         
                         <span class="bxmaker-authuserphone-enter-simpush__phone">{{$root.formattedPhone}}</span>
                         
                         <BXmakerAuthuserphoneLink @onClick="onClickChangePhone">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_SIM_PUSH_CHANGE_PHONE}}
                         </BXmakerAuthuserphoneLink>                     
                    </div>
                </slot>
                                               
                <slot name="captcha">
                    <BXmakerAuthuserphoneCaptcha 
                        :code="$root.captchaCode"
                        :src="$root.captchaSrc"
                        :length="$root.captchaLength"
                        :loader="$root.captchaLoader"
                        @onInput="$root.setCaptchaCode"
                        @onComplete="onCompleteCaptcha"
                        @onRefresh="$root.refreshCaptcha"
                   />
                </slot>
                
                 <slot name="timeout">
                    <BXmakerAuthuserphoneTimeout 
                    :timeout="$root.simPushTimeout"
                     v-if="$root.simPushTimeout"
                     @onComplete="onCompleteTimeout" >  
                        <template v-slot:before>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_SIM_PUSH_TIMEOUT_TITLE}} <br>
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_SIM_PUSH_TIMEOUT_SUBTITLE}} 
                        </template>       
                     </BXmakerAuthuserphoneTimeout>  
                 </slot>             
                
                <slot name="request" v-if="!$root.simPushTimeout" >     
                    <div class="bxmaker-authuserphone-enter-simpush__start" >
                        <BXmakerAuthuserphoneLink @onClick="onClickStart" v-if="!$root.simPushStartLoader">
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_SIM_PUSH_GET_NEW}}   
                         </BXmakerAuthuserphoneLink> 
                         <BXmakerAuthuserphoneLoader class="bxmaker-authuserphone-enter-simpush__start-loader" v-else />
                    </div>   
                </slot>                
                          
                <slot name="check">          
                    <BXmakerAuthuserphoneButton 
                        v-if="!$root.simPushDelay"
                        class="bxmaker-authuserphone-enter-simpush__button-check"
                        :title="$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_SIM_PUSH_BUTTON_CHECK"  
                        :loader="$root.simPushCheckLoader"
                        @onClick="onClickCheck"                         
                    />       
                </slot>
                                
            </div>
        `,
    });